import React, { useCallback } from 'react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { CONSTANTS } from 'wmic-pe-portals-utils-js';
import { useWizardModals } from 'wmic-pe-portals-wizard-components-ui';
import WMICHOCoverageUtil from 'wmic-pe-capability-gateway-common-ho-react/utils/WMICHOCoverageUtil';

import WMICHOCustomCoverageTerm from '../WMICHOCustomCoverageTerm/WMICHOCustomCoverageTerm';
import WMICHOHomeBasedBusinessDetailView from './WMICHOHomeBasedBusinessDetailView/WMICHOHomeBasedBusinessDetailView';
import messages from './WMICHOHomeBasedBusinessCov.messages';

import metadata from './WMICHOHomeBasedBusinessCov.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function WMICHOHomeBasedBusinessCov(props) {
    const {
        id,
        dwellingVM,
        path,
        onUpdateJobAndCoverage,
        readOnly,
        onValidationChange: parentOnValidate,
        showErrors: parentShowErrors,
    } = props;

    const translator = useTranslator();
    const { showConfirm } = useWizardModals();

    const updateJobAndCoverage = async () => {
        const businesses = dwellingVM?.homeBasedBusinessCovItems?.value || [];
        const limitAmount = businesses.reduce((sum, business) => sum + (business.coverageLimit || 0), 0);
        await onUpdateJobAndCoverage(limitAmount, `${path}.terms[0].directValue`);
    };

    const minimumHomeBasedBusinessValidCheck = useCallback(
        () => WMICHOCoverageUtil.isHomeBasedBusinessValid(dwellingVM),
        [dwellingVM]
    );

    const confirmRemoveBusiness = async businessCov => {
        const businessDisplayName = businessCov?.hoBusinessType_WMIC?.value?.description;
        const response = await showConfirm({
            title: translator(messages.removeBusinessConfirmationTitle, { business: businessDisplayName }),
            message: translator(messages.removeBusinessConfirmationMessage, { business: businessDisplayName }),
        });
        return response === CONSTANTS.MODAL_RESULT.CONFIRM;
    };

    const overrideProps = {
        oneBusinessRequiredMessage: {
            visible: !minimumHomeBasedBusinessValidCheck(),
        },
        homeBasedBusinessCoverageList: {
            id,
            addButtonLabel: messages.addBusinessButton,
            coverageItemsVM: dwellingVM?.homeBasedBusinessCovItems,
            detailViewComponent: WMICHOHomeBasedBusinessDetailView,
            dtoType:
                // eslint-disable-next-line no-secrets/no-secrets
                'wmic.edge.ca.capabilities.policyjob.lob.homeownersHOE.coverables.dto.dwelling.HomeBasedBusinessCovItemDTO_WMIC',
            dwellingVM,
            isDeleteDisabledForLastItem: false,
            onComponentValidation: minimumHomeBasedBusinessValidCheck,
            onConfirmRemove: confirmRemoveBusiness,
            onUpdateJobAndCoverage: updateJobAndCoverage,
            onValidationChange: parentOnValidate,
            readOnly,
            showErrors: parentShowErrors,
            VMData: [
                { headerText: translator(messages.businessType), path: 'hoBusinessType_WMIC' },
                { headerText: translator(messages.businessDescription), path: 'description' },
                { headerText: translator(messages.businessCoverageLimit), path: 'coverageLimit' },
                { headerText: translator(messages.businessAnnualGrossReceipts), path: 'annualGrossReceipts' },
            ],
        },
    };

    const resolvers = {
        resolveComponentMap: {
            WMICHOCustomCoverageTerm,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={dwellingVM}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={parentOnValidate}
            showErrors={parentShowErrors}
        />
    );
}
export default WMICHOHomeBasedBusinessCov;
